import { c as _c } from "react/compiler-runtime";
import { addHours, startOfHour, subDays } from 'date-fns';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import { WebhooksListQueryParams } from '../';
import { SeekPagination } from '../../../../../../../../typings/API.interface';
import { APIWebhook } from '../../../../../../../../typings/Webhook.interface';
import { formatNumberShorthand } from '../../../../../utils';
import formatMetricsQuery from '../../../../../utils/formatMetricsQuery';
import { RULE_TYPES } from '../../../../../utils/rules';
import Badge from '../../../../common/base/Badge';
import Button from '../../../../common/base/Button';
import Chip from '../../../../common/base/Chip';
import Container from '../../../../common/base/Container';
import Icon from '../../../../common/base/Icon';
import Loading from '../../../../common/base/Loading';
import Text from '../../../../common/base/Text';
import { useDialog } from '../../../../common/Dialog';
import Dropdown from '../../../../common/Dropdown';
import DropdownMenu from '../../../../common/DropdownMenu';
import { EmptyResults, StyledEmptyStateWrapper } from '../../../../common/EmptyState';
import { Div } from '../../../../common/helpers/StyledUtils';
import { buildPreviewBuckets, GROUP_METRICS_BY_2H, GROUP_METRICS_BY_4H, PreviewMetricEntry } from '../../../../common/Histogram/PreviewHistogram';
import Table from '../../../../common/Table/Table';
import useMetricsQuery from '../../../../hooks/useMetricsQuery';
import useSearchQuery from '../../../../hooks/useSearchQuery';
import { getOrderedRules } from '../Forms/rules';
import { ResourcesContext } from '../ResourcesContext';
import ConnectionPreview from './ConnectionPreview';
import GroupedConnections from './GroupedConnections';
import useOnDisableToggle from './hooks/useOnDisableToggle';
import useOnPauseToggle from './hooks/useOnPauseToggle';
import MetricsPreview from './MetricsPreview';
import { StatusBadge } from './StatusBadge';
const now = addHours(startOfHour(new Date()), 1);
const ConnectionName = t0 => {
  const $ = _c(17);
  const {
    name,
    connection,
    mutate
  } = t0;
  const [isDirty, setIsDirty] = useState(false);
  const showDialog = useDialog();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = dirty => {
      setIsDirty(dirty);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleDirtyChange = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      l: -2
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minWidth: 0
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      min: 408
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isDirty || $[5] !== showDialog) {
    t5 = async () => {
      if (!isDirty) {
        return true;
      }
      return new Promise(resolve => {
        showDialog(() => {
          setIsDirty(false);
          resolve(true);
        }, () => {
          resolve(false);
        }, {
          title: "Discard unsaved changes?",
          message: "You have unsaved changes in the connection details. Are you sure you want to discard them?",
          submit_label: "Discard",
          danger: true,
          cancel_label: "Cancel"
        });
      });
    };
    $[4] = isDirty;
    $[5] = showDialog;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== name) {
    t6 = (opened, toggle) => <Button ghost={true} active={opened} style={{
      maxWidth: "100%"
    }} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}>{name ? <Text as="span" mono={true} ellipsis={true}>{name}</Text> : <Text neutral={true} flex={{
        align: "center",
        gap: 1
      }}>Add<Icon neutral={true} icon="add_circle" pointer={true} /></Text>}</Button>;
    $[7] = name;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["name"];
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== connection || $[11] !== mutate) {
    t8 = <ConnectionPreview connection={connection} fields={t7} mutate={mutate} onDirtyChange={handleDirtyChange} />;
    $[10] = connection;
    $[11] = mutate;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t8) {
    t9 = <Div flex={true} m={t2} min_w={0}><Div onClick={_temp} style={t3}><Dropdown placement="bottom-start" parent_width={t4} portal={true} onBeforeClose={t5} renderToggle={t6}>{t8}</Dropdown></Div></Div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
const ConnectionStatus = t0 => {
  const $ = _c(15);
  const {
    connection,
    mutate
  } = t0;
  const onDisable = useOnDisableToggle("webhooks", mutate);
  const onPause = useOnPauseToggle();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [4, 8];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== connection) {
    t2 = (opened, toggle) => <Button ghost={true} m={-1} p={1} active={opened} onClick={e_0 => {
      toggle(!opened);
      e_0.stopPropagation();
    }}><StatusBadge resource={connection} /></Button>;
    $[1] = connection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== connection || $[4] !== onPause) {
    t3 = connection.paused_at ? {
      icon: "play_circle",
      label: "Unpause connection",
      description: "Resume processing events for this connection.",
      onClick: () => onPause(connection, false)
    } : {
      icon: "pause_circle",
      label: "Pause connection",
      description: "Stops all event delivery. Undelivered events will accumulate until unpaused.",
      onClick: () => onPause(connection, true)
    };
    $[3] = connection;
    $[4] = onPause;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== connection || $[7] !== onDisable) {
    t4 = connection.disabled_at ? {
      icon: "enable",
      label: "Enable connection",
      description: "Accepts all incoming events to this connection.",
      onClick: () => onDisable(connection, false)
    } : {
      icon: "disable",
      label: "Disable connection",
      description: "Stops event delivery and ignores all undelivered attempts.",
      onClick: () => onDisable(connection, true)
    };
    $[6] = connection;
    $[7] = onDisable;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = [t3, t4];
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <Div flex={true}><Div onClick={_temp2}><DropdownMenu placement="bottom-end" ghost={true} offset={t1} renderToggle={t2} icon="horizontal_more" options={t5} /></Div></Div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const ConnectionRules = t0 => {
  const $ = _c(17);
  const {
    connection,
    mutate
  } = t0;
  const [isDirty, setIsDirty] = useState(false);
  const showDialog = useDialog();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (dirty, diff) => {
      setIsDirty(dirty);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleDirtyChange = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      raw: "fit-content"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      min: 624
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [4, 4];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isDirty || $[5] !== showDialog) {
    t5 = async () => {
      if (!isDirty) {
        return true;
      }
      return new Promise(resolve => {
        showDialog(() => {
          setIsDirty(false);
          resolve(true);
        }, () => {
          resolve(false);
        }, {
          title: "Discard unsaved changes?",
          message: "You have unsaved changes in the connection details. Are you sure you want to discard them?",
          submit_label: "Discard",
          danger: true,
          cancel_label: "Cancel"
        });
      });
    };
    $[4] = isDirty;
    $[5] = showDialog;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== connection.rules) {
    t6 = (opened, toggle) => <Button ghost={true} m={-1} p={1} active={opened} flex={{
      align: "center",
      gap: 2
    }} onClick={() => {
      toggle(!opened);
    }}>{connection.rules.length === 0 && <Text neutral={true} flex={{
        align: "center",
        gap: 1
      }}>Add<Icon neutral={true} icon="add_circle" pointer={true} /></Text>}{getOrderedRules(connection.rules).slice(0, 3).map(_temp4)}{getOrderedRules(connection.rules).length > 3 && <Text size="xs" muted={true}>+ {getOrderedRules(connection.rules).length - 3} more</Text>}</Button>;
    $[7] = connection.rules;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["rules"];
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== connection || $[11] !== mutate) {
    t8 = <ConnectionPreview connection={connection} fields={t7} mutate={mutate} onDirtyChange={handleDirtyChange} />;
    $[10] = connection;
    $[11] = mutate;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t8) {
    t9 = <Div w={t2} onClick={_temp3}><Dropdown placement="bottom-start" parent_width={t3} portal={true} offset={t4} onBeforeClose={t5} renderToggle={t6}>{t8}</Dropdown></Div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
type Pagination = SeekPagination & {
  page_size: number;
};
const ConnectionsList = t0 => {
  const $ = _c(45);
  const {
    filtering,
    view,
    connections,
    total,
    loading,
    pagination,
    mutate
  } = t0;
  const [current_page, setCurrentPage] = useState(1);
  const {
    search_term,
    group_by
  } = useContext(ResourcesContext);
  const {
    query: t1,
    updateSearchQuery
  } = useSearchQuery();
  const {
    selected_connection_id
  } = t1;
  const history = useHistory();
  let t2;
  if ($[0] !== connections) {
    const query_params = {
      filters: {
        date: {
          min: subDays(now, 1).toISOString(),
          max: now.toISOString()
        },
        webhook_id: connections?.map(_temp5)
      },
      granularity: "hour" as const,
      dimensions: ["status", "webhook_id"]
    };
    t2 = connections ? formatMetricsQuery("Events", query_params) : null;
    $[0] = connections;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const metrics_query = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      resetResultSetOnChange: false
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    raw_data
  } = useMetricsQuery(metrics_query, t3);
  let t4;
  let t5;
  if ($[3] !== connections || $[4] !== current_page || $[5] !== filtering || $[6] !== group_by || $[7] !== history || $[8] !== loading || $[9] !== mutate || $[10] !== pagination || $[11] !== raw_data || $[12] !== search_term || $[13] !== selected_connection_id || $[14] !== total || $[15] !== updateSearchQuery || $[16] !== view) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const entries = raw_data?.map(_temp6) ?? null;
      const connection_ids = connections.map(_temp7);
      const timeseries_2h_by_connection_id = entries && buildPreviewBuckets(connection_ids, entries, GROUP_METRICS_BY_2H, now);
      const timeseries_4h_by_connection_id = entries && buildPreviewBuckets(connection_ids, entries, GROUP_METRICS_BY_4H, now);
      let t6;
      if ($[19] !== raw_data) {
        t6 = (obj, t7) => {
          const {
            id: id_1
          } = t7;
          obj[id_1] = raw_data?.reduce((acc, entry) => {
            if (entry?.["Events.webhook_id"] === id_1) {
              acc = acc + parseInt(entry?.["Events.count"]);
            }
            return acc;
          }, 0);
          return obj;
        };
        $[19] = raw_data;
        $[20] = t6;
      } else {
        t6 = $[20];
      }
      const count_by_connection_id = connections.reduce(t6, {});
      const grouped_by = connections && Object.entries(connections.reduce((groups, connection) => {
        if (group_by) {
          groups[connection[group_by].id] = [...(groups[connection[group_by].id] || []), connection];
        }
        return groups;
      }, {} as {
        [k: string]: APIWebhook[];
      }));
      if (view === "table") {
        let t7;
        if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = ["Source", "Destination", "Connection Name", "Rules", "Status", "Events (24h)"];
          $[21] = t7;
        } else {
          t7 = $[21];
        }
        let t8;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = [{
            min: 150
          }, {
            min: 150
          }, {
            min: 120
          }, {
            min: 320,
            max: 320
          }, {
            min: 70,
            max: 70
          }, {
            min: 150,
            max: 150
          }];
          $[22] = t8;
        } else {
          t8 = $[22];
        }
        let t9;
        if ($[23] !== history) {
          t9 = id_2 => {
            history.push(`/connections/${id_2}`);
          };
          $[23] = history;
          $[24] = t9;
        } else {
          t9 = $[24];
        }
        const t10 = pagination?.page_size || 50;
        let t11;
        if ($[25] !== current_page || $[26] !== t10) {
          t11 = {
            current_page,
            page_size: t10,
            entity_name: "connections"
          };
          $[25] = current_page;
          $[26] = t10;
          $[27] = t11;
        } else {
          t11 = $[27];
        }
        let t12;
        if ($[28] !== current_page || $[29] !== pagination || $[30] !== updateSearchQuery) {
          t12 = pagination?.next ? () => {
            updateSearchQuery({
              next: pagination.next,
              prev: undefined
            });
            setCurrentPage(current_page + 1);
          } : undefined;
          $[28] = current_page;
          $[29] = pagination;
          $[30] = updateSearchQuery;
          $[31] = t12;
        } else {
          t12 = $[31];
        }
        let t13;
        if ($[32] !== current_page || $[33] !== pagination || $[34] !== updateSearchQuery) {
          t13 = pagination?.prev ? () => {
            updateSearchQuery({
              prev: pagination.prev,
              next: undefined
            });
            setCurrentPage(current_page - 1);
          } : undefined;
          $[32] = current_page;
          $[33] = pagination;
          $[34] = updateSearchQuery;
          $[35] = t13;
        } else {
          t13 = $[35];
        }
        const t14 = loading ? [] : connections.map(connection_0 => ({
          id: connection_0.id,
          selected: selected_connection_id === connection_0.id,
          fields: [<Chip key={connection_0.id} outline={true} mono={true} to={`/sources/${connection_0.source.id}`} label={connection_0.source.name} />, <Chip key={connection_0.id} outline={true} mono={true} to={`/destinations/${connection_0.destination.id}`} label={connection_0.destination.name} />, <ConnectionName key={connection_0.id} name={connection_0.name} connection={connection_0} mutate={mutate || _temp8} />, <ConnectionRules key={connection_0.id} connection={connection_0} mutate={mutate || _temp9} />, <ConnectionStatus key={connection_0.id} connection={connection_0} mutate={mutate || _temp10} />, <Div key={connection_0.id} flex={{
            align: "center",
            gap: 2
          }} min_w={0}><Text w={{
              px: 40
            }} muted={true} number={true}>{formatNumberShorthand(count_by_connection_id?.[connection_0.id] || 0)}</Text><span onClick={_temp11}><MetricsPreview data_2h_sample={timeseries_2h_by_connection_id?.[connection_0.id] || []} data_4h_sample={timeseries_4h_by_connection_id?.[connection_0.id] || []} connection={connection_0} /></span></Div>]
        }));
        let t15;
        if ($[36] !== connections.length || $[37] !== loading || $[38] !== t11 || $[39] !== t12 || $[40] !== t13 || $[41] !== t14 || $[42] !== t9 || $[43] !== total) {
          t15 = <Table headers={t7} top_offset={106} list={true} fill={true} widths={t8} loading={loading} loading_title="Connections loading" loading_message="It may take a few moments to populate your connections." empty_results_label="No connections found" onRowSelected={t9} pagination={t11} onNextPage={t12} onPreviousPage={t13} current_count={connections.length} total_count={total} rows={t14} />;
          $[36] = connections.length;
          $[37] = loading;
          $[38] = t11;
          $[39] = t12;
          $[40] = t13;
          $[41] = t14;
          $[42] = t9;
          $[43] = total;
          $[44] = t15;
        } else {
          t15 = $[44];
        }
        t5 = t15;
        break bb0;
      }
      t4 = <Div id="connections-area" h={100}>{loading ? <Div flex={{
          align: "center",
          justify: "center"
        }} h={100}><Loading loading_title="Connections loading" loading_message="It may take a few moments to populate your connections." /></Div> : connections.length === 0 && (filtering || search_term) ? <StyledEmptyStateWrapper style={{
          height: "100%"
        }}><EmptyResults label="No connections found" /></StyledEmptyStateWrapper> : <Div>{grouped_by?.map(t7 => {
            const [id_3, connections_0] = t7;
            return <GroupedConnections key={id_3} connections={connections_0} mutate={mutate} timeseries_by_connection_id={{
              "2h": timeseries_2h_by_connection_id ?? {},
              "4h": timeseries_4h_by_connection_id ?? {}
            }} />;
          })}{connections.length === 200 && <Container small={true} flex={{
            justify: "center",
            direction: "column"
          }} m={{
            t: 6
          }}><Text bold={true} center={true} as="p"><Icon icon="info" left={true} />You've reached the maximum connection displayed</Text><Text muted={true} center={true} as="p">The dashboard displays up to 200 connections at a time. Use filters, search, and sort above to narrow down your connections list.</Text></Container>}</Div>}</Div>;
    }
    $[3] = connections;
    $[4] = current_page;
    $[5] = filtering;
    $[6] = group_by;
    $[7] = history;
    $[8] = loading;
    $[9] = mutate;
    $[10] = pagination;
    $[11] = raw_data;
    $[12] = search_term;
    $[13] = selected_connection_id;
    $[14] = total;
    $[15] = updateSearchQuery;
    $[16] = view;
    $[17] = t4;
    $[18] = t5;
  } else {
    t4 = $[17];
    t5 = $[18];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  return t4;
};
export default ConnectionsList;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e) {
  return e.stopPropagation();
}
function _temp3(e) {
  return e.stopPropagation();
}
function _temp4(rule) {
  return <Badge key={rule.type} neutral={true} icon={RULE_TYPES[rule.type].icon}>{RULE_TYPES[rule.type].label}</Badge>;
}
function _temp5(t0) {
  const {
    id
  } = t0;
  return id;
}
function _temp6(e) {
  return {
    time: new Date(e["Events.createdAt"]).getTime(),
    count: parseInt(e["Events.count"] || "0", 10),
    id: e["Events.webhook_id"],
    dimension: e["Events.status"]
  };
}
function _temp7(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}
function _temp8() {}
function _temp9() {}
function _temp10() {}
function _temp11(e_0) {
  return e_0.stopPropagation();
}